<template>
  <div class="error-wrap">
    <div class="error-code">500</div>
    <h2 class="error-title">页面加载失败</h2>
    <p class="error-desc">
      菜单或权限数据暂时无法加载，请稍后重试；若问题持续，请联系管理员。
    </p>

    <div class="btn-box">
      <button class="btn retry" @click="retry">重新加载</button>
      <button class="btn home" @click="goHome">回到首页</button>
    </div>
  </div>
</template>

<script>
export default {
  name: "PageServerError",
  methods: {
    // 刷新后会重新请求菜单与角色权限，适合临时网络或服务端异常。
    retry() {
      window.location.reload();
    },
    goHome() {
      this.$router.push("/");
    }
  }
};
</script>

<style lang="scss" scoped>
.error-wrap {
  width: 100%;
  min-height: calc(100vh - 64px);
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 20px;
  box-sizing: border-box;
  background: var(--app-bg);
}

.error-code {
  font-size: 160px;
  font-weight: 900;
  line-height: 1;
  margin-bottom: 20px;
  color: var(--brand);
  text-shadow: var(--glow);
}

.error-title {
  margin: 0 0 12px;
  color: var(--title);
  font-size: 28px;
  font-weight: 600;
}

.error-desc {
  max-width: 580px;
  margin: 0 auto 52px;
  color: var(--text-muted);
  font-size: 16px;
  line-height: 1.75;
  text-align: center;
}

.btn-box {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  gap: 18px;
}

.btn {
  padding: 13px 28px;
  border: none;
  border-radius: var(--card-radius);
  box-shadow: var(--btn-shadow);
  color: #fff;
  cursor: pointer;
  font-size: 15px;
}

.retry {
  background: rgba(12, 113, 207, 0.8);
}

.home {
  background: var(--brand-grad);
}

@media screen and (max-width: 640px) {
  .error-code {
    font-size: 102px;
  }

  .error-title {
    font-size: 22px;
  }
}
</style>
